import React, { lazy, Suspense } from 'react';

const LazyDealerLocatorPage = lazy(() => import('./DealerLocatorPage'));

const DealerLocatorPage = (props: React.JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyDealerLocatorPage {...props} />
  </Suspense>
);

export default DealerLocatorPage;
